module.exports = __webpack_public_path__ + "static/media/Slice27@2x.cae5abc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice27@2x.png
// module id = 1456
// module chunks = 0